var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm.item.type === 'card' ? _c('CardHorizontal', _vm._b({
    staticClass: "item-card",
    attrs: {
      "is-scramble-link": _vm.isScrambleLink
    }
  }, 'CardHorizontal', _vm.item, false)) : _c('MdmLink', {
    staticClass: "item-link d-flex justify-content-between align-items-center flex-shrink-0",
    class: "level-".concat(_vm.level),
    style: _vm.withColor && {
      color: _vm.item.color
    },
    attrs: {
      "is-scramble-link": _vm.isScrambleLink,
      "url": _vm.item.url
    },
    nativeOn: {
      "click": function click($event) {
        return _vm.$root.$emit('generic-tracking', $event, {
          data: _vm.item.tracking
        });
      }
    }
  }, [_vm._v("\n  " + _vm._s(_vm.item.label) + "\n  "), _vm.withArrow ? _c('mdm-icon', {
    staticClass: "p-0 m-0",
    attrs: {
      "size": "20",
      "name": "bx-chevron-right"
    }
  }) : _vm._e()], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };